import script from "./ProgCreatorEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./ProgCreatorEdit.vue?vue&type=script&setup=true&lang=js"

import "./ProgCreatorEdit.vue?vue&type=style&index=0&id=155da57e&lang=scss"

const __exports__ = script;

export default __exports__